import Collection from  './base';
import Location from '../models/location';

export default Collection.extend( {
	model: Location,
	comparator: 'distance',
} );
